import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import fetchEvents from '../../actions/event_list'
import Event from './event'

export class EventList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      events: [],
    }
  }

  componentDidMount() {
    this.props.fetchEvents()
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Event Name</th>
              <th>Event Start Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {this.props.eventList.map((event, index) => {
              return (
                <Event
                  key={index}
                  name={event.name}
                  startTime={event.startTime}
                  id={event._id}
                  item={index + 1}
                />
              )
            })}
          </tbody>
        </table>
      )
    }
  }
}

function mapStateToProps(state) {
  console.log('state: ' + JSON.stringify(state))
  return {
    eventList: state.eventList.events,
    loading: state.eventList.loading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchEvents: fetchEvents,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(EventList)



/** WEBPACK FOOTER **
 ** ./src/components/events/list.js
 **/